@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../settings-page.module.less';

.email-templates-page {
  // nesting is necessary to beat specificity of tab component
  .tab-button {
    color: var(--default--text-color--17);
  }

  .selected-tab-button {
    color: var(--default--text-color--17);
    background-color: @settings-page--tabbed--tab-panel--background-color;
    font-weight: 500;
  }
}

.tab-page-header {
  padding: @settings-page--tabbed--header--padding;
}

.grid-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.tab-content {
  min-height: unset;
  padding: @settings-page--tabbed--tab-panel--padding;
  background-color: @settings-page--tabbed--tab-panel--background-color;
}

.tab-content-max-width {
  max-width: 875px;
}

.warning {
  display: flex;
  background-color: @settings-page--templates-emails--warning--background-color;
  padding: 4px;
  border-radius: 4px;
  margin-top: 16px;
  margin-bottom: 8px;

  .icon {
    padding: 8px;
    border-right: 1px solid @settings-page--templates-emails--warning--border-color;
    margin-top: auto;
    margin-bottom: auto;

    > svg {
      color: @settings-page--templates-emails--warning--text-color;
      height: 16px;
      width: 16px;
    }
  }

  .warning-text {
    font-size: 14px;
    line-height: 1.3;
    padding: 8px;

    p {
      margin: 0;
    }

    span {
      font-weight: 500;
    }
  }
}
